export enum CustomersSubscriptions {
  kcell = 'kcell',
}

export type CustomersSubscriptionApiModel = {
  id: string;
  contract_id: string;
  subscribe_before: string;
  subscription_template: {
    id: string;
    type: CustomersSubscriptions;
    title: string;
    slug: string;
  };
};

export type CustomersSubscriptionApiResponseModel = {
  data: {
    order_subscriptions: CustomersSubscriptionApiModel[];
  };
};

export type CustomersSubscriptionModel = {
  id: string;
  contractId: string;
  expiredAt: string;
  subscriptionTemplate: {
    id: string;
    type: CustomersSubscriptions;
    title: string;
    slug: string;
  };
};

export enum CustomerSubscriptionStatuses {
  created = 'created',
  alreadyActivated = 'ErrorOrderSubscriptionAlreadyActivated',
  unpaid = 'ErrorOrderSubscriptionUnpaid',
  notFound = 'ErrorOrderSubscriptionNotFound',
  customerConflict = 'ErrorOrderSubscriptionCannotBeActivatedByDifferentCustomer',
  unknown = 'unknown',
  loading = 'loading',
  activate = 'activate',
}

export type CustomerSubscriptionErrorModel = {
  type: number;
  message: string;
};
